import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { configService } from 'services/config.service';
import { getAccessToken } from '@timeedit/ui-components';
import { configs } from '../configs';

// Central RTK Query API instance.
// Keep this file minimal: baseQuery + common tagTypes. Extend elsewhere via injectEndpoints.
export const baseApi = createApi({
  reducerPath: 'api',
  tagTypes: [
    'UserIdentity',
    'ObjectJob',
    'AuthConfig',
    'AuthAffiliations',
    'Object',
    'Field',
  ],
  baseQuery: fetchBaseQuery({
    baseUrl:
      configService.REACT_APP_BASE_URL || configs['beta'].REACT_APP_BASE_URL,
    prepareHeaders: (headers) => {
      // Using UI components helper for tokens; optionally switch to redux state if needed.
      const token = getAccessToken?.();
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }

      return headers;
    },
  }),
  endpoints: () => ({}), // Empty; inject in feature-specific files.
});

export const { invalidateTags } = baseApi.util;
